import { checkStatus } from '../../../utilities/fetch';
import { sharingTokens } from '../../../utilities/api_relative_paths';

/**
 * POST: Get sharing token from an specific type of object
 *
 * @param {number} articleId - article id
 * @param {string} type - Type of the object to get sharing token
 * @returns {null|Promise} Promise that can be consumed or null
 */
const getSharingToken = (articleId, type = 'article') => {
  if (!articleId) return null;

  const data = {
    item_id: articleId,
    item_type: type,
  };

  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return fetch(sharingTokens, requestOptions)
    .then(checkStatus)
    .then((response) => response.json())
    .catch((error) => Promise.reject(error));
};

/**
 * POST: Send email address with the article URL
 *
 * @param {number} articleId - article id
 * @param {object} shareByEmail - Object containing email addresses and message to be sent
 * @param {Array} shareByEmail.email_addresses
 * - List of email addresses that will receive the article
 * @param {string} shareByEmail.message - Text message sent in email
 * @param {string} type - Type of the object to get sharing token
 * @returns {null|Promise} Promise that can be consumed or null
 */
const sendEmailArticle = (articleId, shareByEmail, type = 'article') => {
  if (!articleId) return null;

  const data = {
    item_id: articleId,
    item_type: type,
    share_via_email: shareByEmail,
  };

  const requestOptions = {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
    },
  };

  return fetch(sharingTokens, requestOptions)
    .then(checkStatus)
    .then((response) => response.json())
    .catch((error) => Promise.reject(error));
};

export { getSharingToken, sendEmailArticle };
